import gql from 'graphql-tag';
import { ADDRESS_VIEW_MODEL_FRAGMENT } from 'shared';

export const GET_CUSTOMER_CONTACTS = gql`
  query GetCustomerContacts($customerAccountId: ID!) {
    customer {
      customerContacts(customerAccountId: $customerAccountId) {
        error
        success
        list {
          title
          phone
          title
          lastName
          firstName
          contactType
          lastContactDate

          accountContactDetails {
            id
            email

            contactAddress {
              ...AddressFields
            }

            deliveryAddress {
              ...AddressFields
            }
          }

          ownerPgDetails {
            ownerPgId
            creditApplicationId
          }
        }
      }
    }
  }
  ${ADDRESS_VIEW_MODEL_FRAGMENT}
`;
